<section class="table-page cliente-form-modal">
  <header class="cliente-form-modal__header">
    <h2>Nuevo cliente</h2>
    <p>Corporativo, su primera empresa, quien lo administrará y los módulos con los que arranca. Todo junto: un cliente a medias es uno en el que nadie puede entrar.</p>
  </header>

  <div class="cliente-form-modal__body">
    <h3 class="cliente-form-modal__seccion">Cliente</h3>
    <div class="cliente-form-modal__grid">
      <mat-form-field appearance="outline" class="table-page__field">
        <mat-label>Nombre del corporativo</mat-label>
        <input matInput aria-label="Nombre del corporativo" [(ngModel)]="alta.nombreCorporativo" maxlength="45" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="table-page__field">
        <mat-label>Razón social de la empresa</mat-label>
        <input matInput aria-label="Razón social de la empresa" [(ngModel)]="alta.razonSocial" maxlength="200" />
        <mat-hint>Puede agregar más empresas después.</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="table-page__field">
        <mat-label>RFC (opcional)</mat-label>
        <input matInput aria-label="RFC (opcional)" [(ngModel)]="alta.rfc" maxlength="15" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="table-page__field">
        <mat-label>Teléfono (opcional)</mat-label>
        <input matInput aria-label="Teléfono (opcional)" [(ngModel)]="alta.telefono" maxlength="20" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="table-page__field">
        <mat-label>Correo de contacto (opcional)</mat-label>
        <input matInput aria-label="Correo de contacto (opcional)" type="email" [(ngModel)]="alta.correo" maxlength="100" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="table-page__field">
        <mat-label>Representante legal (opcional)</mat-label>
        <input matInput aria-label="Representante legal (opcional)" [(ngModel)]="alta.representanteLegal" maxlength="45" />
      </mat-form-field>
    </div>

    <h3 class="cliente-form-modal__seccion">Primer administrador</h3>
    <p class="cliente-form-modal__nota">
      Entra con este usuario, recibe todos los perfiles de cada módulo contratado y desde <em>Personal</em> da de alta a su gente.
    </p>
    <div class="cliente-form-modal__grid">
      <mat-form-field appearance="outline" class="table-page__field">
        <mat-label>Usuario</mat-label>
        <input matInput aria-label="Usuario" [(ngModel)]="alta.usuario" maxlength="45" autocomplete="off" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="table-page__field">
        <mat-label>Contraseña inicial</mat-label>
        <input matInput aria-label="Contraseña inicial" type="password" [(ngModel)]="alta.password" autocomplete="new-password" />
        <mat-hint *ngIf="!passwordCorta">Mínimo 8 caracteres. Pídale que la cambie al entrar.</mat-hint>
        <mat-hint *ngIf="passwordCorta" class="cliente-form-modal__error">Mínimo 8 caracteres.</mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="table-page__field">
        <mat-label>Nombre</mat-label>
        <input matInput aria-label="Nombre" [(ngModel)]="alta.nombre" maxlength="100" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="table-page__field">
        <mat-label>Apellido paterno</mat-label>
        <input matInput aria-label="Apellido paterno" [(ngModel)]="alta.apellidoPaterno" maxlength="100" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="table-page__field">
        <mat-label>Apellido materno (opcional)</mat-label>
        <input matInput aria-label="Apellido materno (opcional)" [(ngModel)]="alta.apellidoMaterno" maxlength="100" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="table-page__field">
        <mat-label>Correo del administrador</mat-label>
        <input matInput aria-label="Correo del administrador" type="email" [(ngModel)]="alta.correoAdministrador" maxlength="100" />
      </mat-form-field>
    </div>

    <h3 class="cliente-form-modal__seccion">Módulos</h3>
    <mat-form-field appearance="outline" class="table-page__field cliente-form-modal__wide">
      <mat-label>Módulos contratados</mat-label>
      <mat-select multiple [(ngModel)]="elegidos" (selectionChange)="alCambiarModulos()" [disabled]="cargandoModulos">
        <mat-option *ngFor="let modulo of modulos" [value]="modulo.nombre">{{ modulo.nombre }}</mat-option>
      </mat-select>
      <mat-hint *ngIf="cargandoModulos">Consultando catálogo…</mat-hint>
      <mat-hint *ngIf="!cargandoModulos">Al menos uno. Cada módulo lleva su propio cupo y vigencia.</mat-hint>
    </mat-form-field>

    <div class="cliente-form-modal__planes" *ngIf="alta.planes.length > 0">
      <div class="cliente-form-modal__plan" *ngFor="let plan of alta.planes">
        <strong class="cliente-form-modal__plan-nombre">{{ plan.sitio }}</strong>
        <mat-form-field appearance="outline" class="table-page__field">
          <mat-label>Cupo de personas</mat-label>
          <input matInput aria-label="Cupo de personas" type="number" min="1" step="1" [(ngModel)]="plan.cantidadUsuarios" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="table-page__field">
          <mat-label>Vigente hasta</mat-label>
          <input matInput aria-label="Vigente hasta" type="date" [(ngModel)]="plan.vigencia" />
        </mat-form-field>
      </div>
    </div>
  </div>

  <footer class="cliente-form-modal__footer" mat-dialog-actions>
    <button type="button" mat-raised-button class="app-form-btn app-form-btn--secondary app-form-btn--compact"
            [disabled]="guardando" (click)="cancelar()">
      Cancelar
    </button>
    <button type="button" mat-raised-button class="app-form-btn app-form-btn--primary app-form-btn--compact"
            [disabled]="!puedeGuardar" (click)="guardar()">
      <span class="material-icons">domain_add</span>
      {{ guardando ? "Guardando…" : "Dar de alta" }}
    </button>
  </footer>
</section>
